import type { DocumentType } from '../../graphql/generated';
import { gql } from '../../graphql/generated';

const HISTORY_FRAGMENT = gql(`
  fragment sumHistoryStats_history on SlimHistory {
    id
    alphaStats {
      insert
      delete
      comment
      resolve
    }
  }
`);

const sumHistoryStats = (
  histories: DocumentType<typeof HISTORY_FRAGMENT>[],
) => {
  return histories.reduce(
    (acc, history) => {
      return {
        insert: acc.insert + history.alphaStats.insert,
        delete: acc.delete + history.alphaStats.delete,
        comment: acc.comment + history.alphaStats.comment,
        resolve: acc.resolve + history.alphaStats.resolve,
      };
    },
    { insert: 0, delete: 0, comment: 0, resolve: 0 },
  );
};

export default sumHistoryStats;
